var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "info-block" },
    [
      _vm.isInteractive
        ? _c("f-sprite-icon", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.arrow.onclick",
                value: _vm.tooltipText,
                expression: "tooltipText",
                modifiers: { arrow: true, onclick: true }
              }
            ],
            staticClass: "info-block__icon",
            attrs: { "icon-link": this.$options.icons.InfoSmall.id }
          })
        : _c("f-sprite-icon", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.arrow",
                value: _vm.tooltipText,
                expression: "tooltipText",
                modifiers: { arrow: true }
              }
            ],
            staticClass: "info-block__icon",
            attrs: { "icon-link": this.$options.icons.InfoSmall.id }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }